import axios from "axios";
import * as d3 from "d3";
import {
    axisTextDim1,
    colonAnnotation,
    fw_progressive_1way,
    inrFormatter,
    numberFormat,
    responsivefy,
    XaxisAttribute
} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // append the svg object to the body of the page
    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append('svg')
        .attr('width', chart.width + 3 * chart.margin.left + chart.margin.right)
        .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + 3 * chart.margin.left + ',' + chart.margin.top + ')')

    axios.post(url, filterParam).then(res => {
        let data = res.data;
        var sumstat = d3.nest() // nest function allows to group the calculation per level of a factor
            .key((d) => {
                return d.dim1_name
            })
            .rollup(function (d) {
                let q1, median, mean, q3, interQuantileRange;
                q1 = d3.quantile(d.map(function (g) {
                    return g.metric1;
                }).sort(d3.ascending), .25)
                median = d3.quantile(d.map(function (g) {
                    return g.metric1;
                }).sort(d3.ascending), .5)
                mean = d3.mean(d.map(function (g) {
                    return g.metric1;
                }));
                q3 = d3.quantile(d.map(function (g) {
                    return g.metric1;
                }).sort(d3.ascending), .75)
                interQuantileRange = q3 - q1;
                let min, max;
                min = q1 - 1.5 * interQuantileRange
                max = q3 + 1.5 * interQuantileRange
                return ({
                    q1: q1,
                    median: median,
                    mean: mean,
                    q3: q3,
                    interQuantileRange: interQuantileRange,
                    min: min,
                    max: max
                })
            })
            .entries(data)

        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
        var y1tip = tooltip_class()

        y1tip.attr('class', 'd3-tip'+divId.id)
             .html(function (d) {
                return (d.key
                    + '<br> Max'+ colonAnnotation +numberFormat(d.value.max)
                    + '<br> Q3'+ colonAnnotation +numberFormat(d.value.q3)
                    + '<br> Median'+ colonAnnotation +numberFormat(d.value.median)
                    + '<br> Q1'+ colonAnnotation +numberFormat(d.value.q1)
                    + '<br> Min'+ colonAnnotation +numberFormat(d.value.min))
            })*/

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        // Show the X and Y scale
        var x1Scale = d3.scaleLinear().domain([0, d3.max(data, d => {
            return +d.metric1
        })]).range([0, chart.width])
        var y1Scale = d3.scaleBand().range([chart.height, 0]).domain(data.map((d) => {
            return d.dim1_name
        })).padding(.4);
        var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way)

        svg.append("g")
            .attr("transform", "translate(0," + chart.height + ")")
            .call(d3.axisBottom(x1Scale)
                .tickFormat(inrFormatter))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .select(".domain");

        svg.append("g")
            .call(d3.axisLeft(y1Scale))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'start')
            .attr('dx', XaxisAttribute)
            .text(axisTextDim1);

        //svg.call(y1tip);

        // Color scale
        var metric2ColorScale = d3.scaleSequential().interpolator(d3.interpolateInferno).domain([4, 8])

        // Add X axis label:
        svg.append("text")
            .attr("text-anchor", "end")
            .attr("x", chart.width / 2)
            .attr("y", chart.height + chart.margin.top + 10 * chart.axisLabelDistance)
            .text(chart.x1AxisDisplayName)
            .style("fill", fontColor)
            .style('font-size', fontSize);

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left - 40 * chart.axisLabelDistance)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        // Show the main vertical line
        svg.selectAll("vertLines")
            .data(sumstat)
            .enter()
            .append("line")
            .attr("x1", (d) => {
                return (x1Scale(d.value.min))
            })
            .attr("x2", (d) => {
                return (x1Scale(d.value.max))
            })
            .attr("y1", (d) => {
                return (y1Scale(d.key) + y1Scale.bandwidth() / 2)
            })
            .attr("y2", (d) => {
                return (y1Scale(d.key) + y1Scale.bandwidth() / 2)
            })
            .attr("stroke", "black")
            .style("width", "1px")

        // rectangle for the main box
        svg.selectAll("boxes")
            .data(sumstat)
            .enter()
            .append("rect")
            .attr("x", d => {
                return (x1Scale(d.value.q1))
            })
            .attr("width", (d) => {
                return (x1Scale(d.value.q3) - x1Scale(d.value.q1))
            })
            .attr("y", (d) => {
                return y1Scale(d.key)
            })
            .attr("height", y1Scale.bandwidth())
            .attr("stroke", "black")
            .style("fill", metric1ColorScale)
            .style("opacity", 0.3)
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(d.key
                    + '<br> Max' + colonAnnotation + numberFormat(d.value.max)
                    + '<br> Q3' + colonAnnotation + numberFormat(d.value.q3)
                    + '<br> Median' + colonAnnotation + numberFormat(d.value.median)
                    + '<br> Q1' + colonAnnotation + numberFormat(d.value.q1)
                    + '<br> Min' + colonAnnotation + numberFormat(d.value.min)
                )
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            })
        //.on('mouseover', y1tip.show)
        //.on('mouseout', y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        // Show the median
        svg.selectAll("medianLines")
            .data(sumstat)
            .enter()
            .append("line")
            .attr("y1", (d) => {
                return (y1Scale(d.key) - y1Scale.bandwidth() / 2) + 32
            })
            .attr("y2", (d) => {
                return (y1Scale(d.key) + y1Scale.bandwidth() / 2) + 35
            })
            .attr("x1", (d) => {
                return (x1Scale(d.value.median))
            })
            .attr("x2", (d) => {
                return (x1Scale(d.value.median))
            })
            .attr("stroke", chart.vizSpecific4)
            .attr("stroke-width", "2")

        svg.selectAll("meanLines")
            .data(sumstat)
            .enter()
            .append("line")
            .attr("y1", (d) => {
                return (y1Scale(d.key) - y1Scale.bandwidth() / 2) + 32
            })
            .attr("y2", (d) => {
                return (y1Scale(d.key) + y1Scale.bandwidth() / 2) + 35
            })
            .attr("x1", (d) => {
                return (x1Scale(d.value.mean))
            })
            .attr("x2", (d) => {
                return (x1Scale(d.value.mean))
            })
            .attr("stroke", chart.vizSpecific5)
            .attr("stroke-width", "3")

        svg.append('text')
            .attr('x', chart.width - 100)
            .attr('y', 10)
            .attr('dy', '0.32em')
            .attr("fill", chart.vizSpecific5)
            .text("- MeanLine")

        svg.append('text')
            .attr('x', chart.width - 100)
            .attr('y', 30)
            .attr('dy', '0.32em')
            .attr("fill", "black")
            .text("- MedianLine")

        // Add individual points with jitter
        var jitterWidth = chart.vizSpecific1
        svg.selectAll("indPoints")
            .data(data)
            .enter()
            .append("circle")
            .attr("cx", (d) => {
                return (x1Scale(d.metric1))
            })
            .attr("cy", function (d) {
                return (y1Scale(d.dim1_name) + (y1Scale.bandwidth() / 2) - jitterWidth / 2 + Math.random() * jitterWidth)
            })
            .attr("r", 4)
            .style("fill", (d) => {
                return (metric2ColorScale(+d.metric1))
            })
            .attr("stroke", "black")
    })
}
